import React from "react";
import {Dialog, TextInputField, toaster} from "evergreen-ui";
import {editCartAmount, getCurrency} from "../util";
import {connect} from "react-redux";
import {updateCartData} from "../external/actions";
import External from "../external/external";


class EditAmountDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            price: 0
        };
    };

    componentDidMount() {
        this.setState({
            price: this.props.cart && this.props.cart.cartPrice
        })
    };

    inputChange = async (e) => {
        console.log({e})
        this.setState({
            price: parseFloat(e.target.value)
        })
    };

    editAmount = async () => {
        const {
            price
        } = this.state;
        const {
            cart,
            showDialog,
            source,
            editAmountData,
            showUnavailabilityDialog,
        } = this.props;

        showDialog(false);
        if (source === "checkout") {
            await this.props.dispatch(updateCartData(editCartAmount(cart, price)))
        } else if (source === "availability") {
            const bookingAmountUpdate = await External.updateBookingAmount({
                bookingId: editAmountData["bookingId"],
                amount: price
            });
            if (bookingAmountUpdate.data["requestStatus"]) {
                await showUnavailabilityDialog(true, editAmountData["slot"]);
                toaster.success("Updated Booking Amount", {
                    id: "booking-amount-update"
                })
            } else {
                toaster.warning(bookingAmountUpdate.data["message"], {
                    id: "booking-amount-update"
                })
            }
        }
    };

    render() {

        const {
            isShown,
            showDialog
        } = this.props;

        return (
            <Dialog
                isShown={isShown}
                onCloseComplete={() => showDialog(false)}
                title={"Edit Amount"}
                onConfirm={this.editAmount}
            >
                <TextInputField
                    label={`Enter amount in ${getCurrency()}`}
                    onChange={(e) => this.inputChange(e)}
                />
            </Dialog>
        )
    }
}

const mapStateToProps = (
    {
        cart,
    }) => ({
        cart,
    }
);

export default connect(mapStateToProps)(EditAmountDialog);
